import styled from "styled-components";
import {RiTreasureMapFill} from "react-icons/ri";
import {FaLaptopCode} from "react-icons/fa";
import {AiFillTool} from "react-icons/ai";
import {BsTextLeft} from "react-icons/bs";
import curveLine from "../../img/curve-line.png";
import curveLine_2 from "../../img/curve_line_2.png";
import curveLine_3 from "../../img/curve_line_3.png";
import Fade from 'react-reveal/Fade';

function ProjectUs(){

    return(
        <div className="layout">
            <Title className=" title-padding-1-bottom">
                <Fade top>
                    Projekt s námi
                </Fade>
            </Title>
            <Project>
                <SideLine>
                    <Block SideLine>
                        <BlockWidth>
                            <Icon>
                                <RiTreasureMapFill/>
                            </Icon>
                            <BlockTitle SideLine className="f-inter">
                                Plánování a návrh
                            </BlockTitle>
                            <Text>
                                Klíčové kroky při vytváření webové stránky nebo aplikace. V této fázi se definují cíle projektu, požadavky a potřeby uživatelů, a vytváří se plán projektu. Důležitým prvkem je i návrh uživatelského rozhraní a designu, který musí být funkční, estetický a uživatelsky přívětivý. Kvalitní plánování a návrh minimalizují problémy během vývoje a testování.
                            </Text>
                        </BlockWidth>
                    </Block>
                    <Block NotLine className="block-notLine">
                        <BlockWidth>
                            <CurveLine FirstLine>
                                <img src={curveLine} className="firstLine" alt="curve-line"/>
                            </CurveLine>
                        </BlockWidth>
                    </Block>
                </SideLine>
                <MiddleLine>
                <Block MiddleLine>
                    <CurveLine SecondLine>
                        <img src={curveLine_3} className="secondLine" alt="curve-line"/>
                    </CurveLine>
                    <BlockWidth>
                        <Icon>
                            <FaLaptopCode/>
                        </Icon>
                        <BlockTitle className="f-inter">
                            Vývoj a testování
                        </BlockTitle>
                        <Text>
                            Zahrnuje tvorbu textů, obrázků a multimediálních prvků. V této fázi se rozhoduje o stylu psaní, designu a umístění grafiky. Kvalitní obsah přiláká uživatele a pomůže k úspěchu webových stránek a aplikací.
                        </Text>
                    </BlockWidth>
                </Block>
                <Block MiddleLine>
                    <CurveLine ThirdLine>
                        <img src={curveLine_2} className="thirdLine" alt="curve-line"/>
                    </CurveLine>
                        <BlockWidth>
                            <Icon>
                                <BsTextLeft/>
                            </Icon>
                            <BlockTitle className="f-inter">
                                Tvorba obsahu
                            </BlockTitle>
                            <Text>
                                Zahrnuje tvorbu textů, obrázků a multimediálních prvků. V této fázi se rozhoduje o stylu psaní, designu a umístění grafiky. Kvalitní obsah přiláká uživatele a pomůže k úspěchu webových stránek a aplikací.
                            </Text>
                        </BlockWidth>
                    </Block>
                </MiddleLine>
                <SideLine>
                    <Block SideLine>
                        <BlockWidth>
                            <Icon>
                                <AiFillTool/>
                            </Icon>
                            <BlockTitle SideLine className="f-inter">
                                Nasazení a údržba
                            </BlockTitle>
                            <Text>
                                Po dokončení vývoje se provede nasazení na cílový server a testování v reálném prostředí. Poté následuje pravidelná údržba, aktualizace a opravy chyb, aby byla zajištěna bezproblémová funkčnost a bezpečnost. Tato fáze je klíčová pro dlouhodobou životnost webového projektu.
                            </Text>
                        </BlockWidth>
                    </Block>
                    <Block NotLine className="block-notLine">
                        <BlockWidth>
                        </BlockWidth>
                    </Block>
                </SideLine>
            </Project>
        </div>
    );
}

const Title = styled.div`
  text-align: center;
  font-size: 64px;
  font-weight: bold;
  color:var(--main-color);
  @media only screen and (max-width: 700px){
    font-size:42px;
  }
  
`;
const Text = styled.div`
  margin-top:10px;
  font-size:18px;
`;
const Project = styled.div`
  display:flex;
  @media only screen and (max-width: 1050px){
    display:block;
    .block-notLine{
    display:none;
    }
    
  }
`;
const Block = styled.div`
  position:relative;  
  background-color:${props =>  props.SideLine ? "white" : props.MiddleLine ? "white" : props.NotLine? "#F5F5F5FF" : "#e8e8e8"};
  width: 100%;
  height: ${props =>  props.SideLine ? "550px" : props.MiddleLine ? "400px" : "250px"};
  background:${props => props.NotLine? "linear-gradient(360deg,rgba(245,245,245,1) 20%,rgba(255,255,255,1) 70%)": ""};
  border-radius: 20px;
  margin-bottom:20px;
  @media only screen and (max-width: 1050px){
    height:auto;
    padding-bottom:30px;
    margin-bottom:30px;
  }
`;
const CurveLine = styled.div`
  img{
    position:absolute;
  }
  .firstLine{
    width: 100%;
    top: -33%;
    left: 32%;
    z-index: 1;
  }
  .secondLine{
    top: -13%;
    left: 84%;
    z-index: 1;
  }
  .thirdLine{
    top: -27%;
    left: 50%;
    z-index: 1;
  }
  @media only screen and (max-width: 1050px){
    display:none;
  }
`;
const BlockWidth = styled.div`
  padding: ${props => props.SideLine ? 50 : 40}px;
`;
const Icon = styled.div`
  padding-bottom:8px;
  color: ${props => props.inputColor || "#C92F34FF"};
  svg{
    font-size:48px;
    path{
      margin:0;
      padding:0;
    }
  }
  
    `;
const BlockTitle = styled.div`
  font-size:24px;
  font-weight: bold;
`;
const SideLine = styled.div`
  flex:0.8;
  
`;
const MiddleLine = styled.div`
  flex:1;
  margin:0 20px 0 20px;
  @media only screen and (max-width: 1050px){
    margin:0;
  }
`;

export default ProjectUs;